import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import vatInformationActions from '../actions/vatInformation';
import companyLocationActions from '../actions/companyLocation';
import reviewPageActions from '../actions/reviewPage';
import helpActions from '../actions/help';

function sendIneligibleEmail(store) {
    const state = store.getState();
    const {vatInformation, userInfoDetails} = state;

    const data = (userInfoDetails.userInfoMetadata.ipm.companyRegistration) ? {
        firstName: userInfoDetails.userInfoMetadata.user.firstName,
        lastName: userInfoDetails.userInfoMetadata.user.lastName,
        emailAddress: userInfoDetails.userInfoMetadata.user.emailAddress,
        companyName: userInfoDetails.userInfoMetadata.user.companyName,
        companyLocation: userInfoDetails.userInfoMetadata.companyCountryCode,
        vatStatus: 'No',
        propertyCount: userInfoDetails.userInfoMetadata.ipm.propertyCount,
        message: 'INVALID_VAT_NUMBER'
    } : {
        firstName: vatInformation.vatMetadata.userInformation.user.firstName,
        lastName: vatInformation.vatMetadata.userInformation.user.lastName,
        emailAddress: vatInformation.vatMetadata.userInformation.user.emailAddress,
        companyName: vatInformation.vatMetadata.userInformation.user.companyName,
        companyLocation: vatInformation.vatMetadata.companyCountryInfo.countryName,
        vatStatus: 'Yes',
        propertyCount: vatInformation.vatMetadata.userInformation.ipm.propertyCount,
        message: 'INVALID_VAT_NUMBER'
    };
    const helpFormData = {
        data,
        type: 'INELIGIBLE'
    };
    store.dispatch(helpActions.submitHelpForm(helpFormData));
}

function handleIPMFlow(store, error, response) {
    const companyRegistration = store.getState().userInfoDetails.userInfoMetadata.ipm.companyRegistration;

    if (error) {
        store.dispatch(actions.enableLoadOverLay(false));
        store.dispatch(vatInformationActions.alertError('internal.server.error'));
    } else if (response.statusCode === 204) {
        store.dispatch(actions.changeAppState('LISTING_MODEL'));
    } else if (companyRegistration) {
        const parsedResponse = JSON.parse(response.text);
        if (parsedResponse.code >= 400) {
            sendIneligibleEmail(store);
            store.dispatch(actions.changeAppState('LISTING_MODEL'));
        }
    } else {
        const parsedResponse = JSON.parse(response.text);
        if (parsedResponse.code === 715) {
            sendIneligibleEmail(store);
            store.dispatch(actions.showIneligibleForm('INVALID_VAT_NUMBER'));
        } else {
            store.dispatch(actions.enableLoadOverLay(false));
            store.dispatch(vatInformationActions.alertError('ipmob.error.process.request'));
        }
    }
}

function handlePPMFlow(store, error, response) {
    if (error) {
        store.dispatch(actions.enableLoadOverLay(false));
        store.dispatch(reviewPageActions.alertErrorForModal('internal.server.error'));
    } else if (response.statusCode === 204) {
        store.dispatch(reviewPageActions.updateServiceSuccess());
    } else {
        store.dispatch(actions.enableLoadOverLay(false));
        store.dispatch(reviewPageActions.alertErrorForModal('ipmob.error.process.request'));
    }
}

function handleBillingSetupFlow(store, error, response, isFromCompanyLocation) {
    if (error) {
        store.dispatch(actions.enableLoadOverLay(false));
        if (isFromCompanyLocation) {
            store.dispatch(companyLocationActions.alertError('internal.server.error'));
        } else {
            store.dispatch(vatInformationActions.alertError('internal.server.error'));
        }
    } else if (response.statusCode === 204) {
        store.dispatch(actions.changeAppState('BILLING_INFORMATION'));
    } else {
        const parsedResponse = JSON.parse(response.text);
        if (parsedResponse.code === 715) {
            store.dispatch(actions.enableLoadOverLay(false));
            if (isFromCompanyLocation) {
                store.dispatch(companyLocationActions.alertError('ipmob.company_location.error.invalid_registration'));
            } else {
                store.dispatch(vatInformationActions.alertError('ipmob.vat_page.error.invalid_vat'));
            }
        } else {
            store.dispatch(actions.enableLoadOverLay(false));
            if (isFromCompanyLocation) {
                store.dispatch(companyLocationActions.alertError('ipmob.error.process.request'));
            } else {
                store.dispatch(vatInformationActions.alertError('ipmob.error.process.request'));
            }
        }
    }
}

function updateVatDetails(store, action) {
    const vatDetails = action.payload.vatDetails;
    const isBillingSetupFlow = action.payload.isBillingSetupFlow;
    const isFromCompanyLocation = !!action.payload.isFromCompanyLocation;
    request.post(`/${config.url_prefix}/api/updateVatDetails?isBillingSetupFlow=${isBillingSetupFlow}`)
        .send({
            data: vatDetails
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            const {app} = store.getState();
            if (isBillingSetupFlow) {
                handleBillingSetupFlow(store, error, response, isFromCompanyLocation);
            } else if (app.userType === 'IPM') {
                handleIPMFlow(store, error, response);
            } else {
                handlePPMFlow(store, error, response);
            }
        });
}

export default updateVatDetails;
